import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { CardTab, DataCardWithTabs } from '@/components/card'
import {
  PipelineCheckFailedProvisionTable,
  PipelineCheckPastProvisionTable
} from '@/components/PipelineCheck'
import { TitleSetter } from '@/components/Title'
import { useFailedProvisionStore, usePastProvisionStore } from '@/stores/pipelineCheck'

export const PipelineCheckView = () => {
  const navigate = useNavigate()
  const { '*': tabParam } = useParams()

  const { data: pastProvision } = usePastProvisionStore(
    useShallow((state) => ({
      data: state.data
    }))
  )

  const { data: failedProvision } = useFailedProvisionStore(
    useShallow((state) => ({
      data: state.data
    }))
  )

  const { fetchData: fetchPastProvision, resetState: resetPastProvision } = usePastProvisionStore(
    useShallow((state) => ({
      fetchData: state.fetchData,
      resetState: state.resetState
    }))
  )

  const { fetchData: fetchFailedProvision, resetState: resetFailedProvision } =
    useFailedProvisionStore(
      useShallow((state) => ({
        fetchData: state.fetchData,
        resetState: state.resetState
      }))
    )

  const TABS = [
    {
      value: 'past-provisioned',
      label: `Past Provisioned (${pastProvision.length})`
    },
    {
      value: 'failed-to-provision',
      label: `Failed to Provision (${failedProvision.length})`
    }
  ]

  const DEFAULT_TAB = TABS[0].value
  const tab = TABS.some((t) => t.value === tabParam) ? tabParam : undefined

  useEffect(() => {
    if (!tab) {
      navigate(`/admin/pipeline-check/${DEFAULT_TAB}`, { replace: true })
    }
  }, [tab, navigate])

  useEffect(() => {
    fetchPastProvision()
    fetchFailedProvision()

    return () => {
      resetPastProvision()
      resetFailedProvision()
    }
  }, [])

  return (
    <>
      <TitleSetter title="Pipeline Check" />

      <DataCardWithTabs
        title="Pipeline Check"
        tabs={TABS}
        currentTab={tab || DEFAULT_TAB}
        onTabChange={(tab) => {
          navigate(`/admin/pipeline-check/${tab}`, { replace: true })
        }}
      >
        <CardTab value="past-provisioned">
          <PipelineCheckPastProvisionTable />
        </CardTab>
        <CardTab value="failed-to-provision">
          <PipelineCheckFailedProvisionTable />
        </CardTab>
      </DataCardWithTabs>
    </>
  )
}
